<template>
  <div>
    <div class="px-4 py-2 mb-3 text-red-700 bg-red-200 rounded-md" v-if="errors.length">
      <div v-for="error in errors" :key="error.message">
        {{ error.message }}
      </div>
    </div>

    <form @submit.prevent="resetPassword()" :disabled="submitting">
      <div v-if="success">
        <div>We've sent your new password to</div>
        <div class="font-bold">{{ form.email }}</div>
      </div>
      <div v-else>
        <p>Enter your email address and we'll email you a new password.</p>
        <fieldset class="mt-4 form-group">
          <label class="form-label">Email Address</label>
          <input ref="initial" id="email" class="form-input" placeholder="Email Address" v-model="form.email">
        </fieldset>
        <button type="submit" class="w-full mb-2 btn btn-accent" v-submitting="submitting">
          Reset Password
        </button>
      </div>
      <router-link :to="{ name: 'CustomerLogin' }" class="block w-full mt-6 text-center hover:underline text-accent">
        &larr; Back to Login
      </router-link>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CustomerResetPassword',

  mounted () {
    this.$refs.initial.focus()
  },

  computed: {
    ...mapState(['portal'])
  },

  data () {
    return {
      success: false,
      submitting: false,
      errors: [],
      form: {
        email: this.$route.query.email
      }
    }
  },

  methods: {
    ...mapActions('customer', ['syncCustomer']),

    async resetPassword () {
      try {
        this.submitting = true
        this.form.email = this.form.email.toLowerCase()
        await this.$api.post(`portal/${this.portal.subdomain}/auth/customer/reset-password`, this.form)
        this.success = true
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
        this.errors = error.response.data.errors ? error.response.data.errors : []
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
